import { HTTP_CP_Company } from '@api-new/companyservice';
import { HTTP_CP_ClientUser } from '@api-new/userservice';
import { createSelector } from '@ngrx/store';
import { WelcomeScreenInputModel } from '@platform/dashboard/models/welcome-screen-template-model.model';
import { selectClientUser } from '@shared/store/client-user/client-user.selectors';
import { selectIsExperianCompany } from '@shared/store/common.selectors';
import { selectCompany } from '@shared/store/company/company.selectors';

export const selectWelcomeModalData = createSelector(
  selectCompany,
  selectClientUser,
  selectIsExperianCompany,
  (company: HTTP_CP_Company, user: HTTP_CP_ClientUser, isExperianCompany: boolean): WelcomeScreenInputModel | null => {
    return {
      clientUserData: null,
      primaryColor: company?.primaryColor,
      logo: company?.logo,
      creationMethod: user?.creationMethod,
      isExperianCompany,
    };
  },
);
